/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Subscribe_NowInputs */

const en_plan_subscribe_now = /** @type {(inputs: Plan_Subscribe_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe now`)
};

const es_plan_subscribe_now = /** @type {(inputs: Plan_Subscribe_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse ahora`)
};

/**
* | output |
* | --- |
* | "Subscribe now" |
*
* @param {Plan_Subscribe_NowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_subscribe_now = /** @type {((inputs?: Plan_Subscribe_NowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Subscribe_NowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_subscribe_now(inputs)
	return en_plan_subscribe_now(inputs)
});